export default "__VITE_ASSET__BCn1YqbF__"